/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
    type V1DatalakeItem,
    V1DatalakeItemFromJSON,
    V1DatalakeItemToJSON
} from '../models/V1DatalakeItem'
import {
    type V1DatalakeItemList,
    V1DatalakeItemListFromJSON,
    V1DatalakeItemListToJSON
} from '../models/V1DatalakeItemList'
import {
    type V1ErrorResponse,
    V1ErrorResponseFromJSON,
    V1ErrorResponseToJSON
} from '../models/V1ErrorResponse'
import {
    type V1RevealedProgramme,
    V1RevealedProgrammeFromJSON,
    V1RevealedProgrammeToJSON
} from '../models/V1RevealedProgramme'

export interface DeleteDatalakeItemRequest {
    /**
     *
     */
    v1DatalakeItem: V1DatalakeItem
}

export interface GetDatalakeItemsRequest {
    /**
     * Filter by item ID
     */
    id?: string
    /**
     * Filter by correlation ID
     */
    corellationId?: string
    /**
     * Filter by kind of item
     */
    kind?: Array<string>
    /**
     * Filter by version
     */
    version?: string
    /**
     * Filter by user ID
     */
    userId?: string
    /**
     * Filter by organization ID
     */
    orgId?: string
    /**
     * Filter by public visibility
     */
    isPublic?: boolean
    /**
     * Skip older records
     */
    lastUpdatedAfter?: number
    /**
     * Limit number of items to return
     */
    items?: number
    /**
     * Skip a certain number of items (for pagination)
     */
    skip?: number
}

export interface GetSharedProgrammeRequest {
    /**
     *
     */
    id: string
    /**
     *
     */
    contentVersion?: number
}

export interface UpdateDatalakeItemRequest {
    /**
     *
     */
    v1DatalakeItem: V1DatalakeItem
}

/**
 *
 */
export class DatalakeApi extends runtime.BaseAPI {
    /**
     * Creates request options for deleteDatalakeItem without sending the request
     */
    async deleteDatalakeItemRequestOpts(
        requestParameters: DeleteDatalakeItemRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['v1DatalakeItem'] == null) {
            throw new runtime.RequiredError(
                'v1DatalakeItem',
                'Required parameter "v1DatalakeItem" was null or undefined when calling deleteDatalakeItem().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        headerParameters['Content-Type'] = 'application/json'

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/datalake`

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: V1DatalakeItemToJSON(requestParameters['v1DatalakeItem'])
        }
    }

    /**
     * Delete a DataLake item
     */
    async deleteDatalakeItemRaw(
        requestParameters: DeleteDatalakeItemRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1DatalakeItem>> {
        const requestOptions =
            await this.deleteDatalakeItemRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1DatalakeItemFromJSON(jsonValue)
        )
    }

    /**
     * Delete a DataLake item
     */
    async deleteDatalakeItem(
        requestParameters: DeleteDatalakeItemRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1DatalakeItem> {
        const response = await this.deleteDatalakeItemRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for getDatalakeItems without sending the request
     */
    async getDatalakeItemsRequestOpts(
        requestParameters: GetDatalakeItemsRequest
    ): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id']
        }

        if (requestParameters['corellationId'] != null) {
            queryParameters['corellationId'] =
                requestParameters['corellationId']
        }

        if (requestParameters['kind'] != null) {
            queryParameters['kind'] = requestParameters['kind']
        }

        if (requestParameters['version'] != null) {
            queryParameters['version'] = requestParameters['version']
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId']
        }

        if (requestParameters['orgId'] != null) {
            queryParameters['orgId'] = requestParameters['orgId']
        }

        if (requestParameters['isPublic'] != null) {
            queryParameters['isPublic'] = requestParameters['isPublic']
        }

        if (requestParameters['lastUpdatedAfter'] != null) {
            queryParameters['lastUpdatedAfter'] =
                requestParameters['lastUpdatedAfter']
        }

        if (requestParameters['items'] != null) {
            queryParameters['items'] = requestParameters['items']
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip']
        }

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/datalake`

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Get DataLake items
     */
    async getDatalakeItemsRaw(
        requestParameters: GetDatalakeItemsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1DatalakeItemList>> {
        const requestOptions =
            await this.getDatalakeItemsRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1DatalakeItemListFromJSON(jsonValue)
        )
    }

    /**
     * Get DataLake items
     */
    async getDatalakeItems(
        requestParameters: GetDatalakeItemsRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1DatalakeItemList> {
        const response = await this.getDatalakeItemsRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for getSharedProgramme without sending the request
     */
    async getSharedProgrammeRequestOpts(
        requestParameters: GetSharedProgrammeRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSharedProgramme().'
            )
        }

        const queryParameters: any = {}

        if (requestParameters['contentVersion'] != null) {
            queryParameters['contentVersion'] =
                requestParameters['contentVersion']
        }

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/datalake/programmes/{id}`
        urlPath = urlPath.replace(
            '{id}',
            encodeURIComponent(String(requestParameters['id']))
        )

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Holders get published snapshots only: the version in contentVersion (the one their enrollment started from) or the latest published one. The owner without contentVersion gets the live source.
     * Programme the caller holds a p.ref to (purchase or coach delivery), or owns
     */
    async getSharedProgrammeRaw(
        requestParameters: GetSharedProgrammeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1RevealedProgramme>> {
        const requestOptions =
            await this.getSharedProgrammeRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1RevealedProgrammeFromJSON(jsonValue)
        )
    }

    /**
     * Holders get published snapshots only: the version in contentVersion (the one their enrollment started from) or the latest published one. The owner without contentVersion gets the live source.
     * Programme the caller holds a p.ref to (purchase or coach delivery), or owns
     */
    async getSharedProgramme(
        requestParameters: GetSharedProgrammeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1RevealedProgramme> {
        const response = await this.getSharedProgrammeRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for updateDatalakeItem without sending the request
     */
    async updateDatalakeItemRequestOpts(
        requestParameters: UpdateDatalakeItemRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['v1DatalakeItem'] == null) {
            throw new runtime.RequiredError(
                'v1DatalakeItem',
                'Required parameter "v1DatalakeItem" was null or undefined when calling updateDatalakeItem().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        headerParameters['Content-Type'] = 'application/json'

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/datalake`

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: V1DatalakeItemToJSON(requestParameters['v1DatalakeItem'])
        }
    }

    /**
     * Create or update a new DataLake entry
     */
    async updateDatalakeItemRaw(
        requestParameters: UpdateDatalakeItemRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1DatalakeItem>> {
        const requestOptions =
            await this.updateDatalakeItemRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1DatalakeItemFromJSON(jsonValue)
        )
    }

    /**
     * Create or update a new DataLake entry
     */
    async updateDatalakeItem(
        requestParameters: UpdateDatalakeItemRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1DatalakeItem> {
        const response = await this.updateDatalakeItemRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }
}
